import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.4984 17.2214C12.3401 17.2214 12.1818 17.163 12.0568 17.038L6.62344 11.6047C5.7401 10.7214 5.7401 9.27135 6.62344 8.38802L12.0568 2.95469C12.2984 2.71302 12.6984 2.71302 12.9401 2.95469C13.1818 3.19635 13.1818 3.59635 12.9401 3.83802L7.50677 9.27135C7.10677 9.67135 7.10677 10.3214 7.50677 10.7214L12.9401 16.1547C13.1818 16.3964 13.1818 16.7964 12.9401 17.038C12.8151 17.1547 12.6568 17.2214 12.4984 17.2214Z",
		fill: "white"
	})
});
export default SvgArrowLeft;
